import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { AuditoriaType } from "../types";

export default async  function getAuditoria (
  usuario?: string, 
  tabela?: string, 
  periodoInicial?: string, 
  periodoFinal?: string, 
  page = 1
) {
  const { data } = await api.get<Paginate<AuditoriaType>>(
    `${URLS.AUDITORIA_API}`,
    {
      params: {
        usuario,
        tabela,
        periodoInicial,
        periodoFinal,
        page,
      }
    }
  );

  return data;
}

export async function getAuditoriaForId(auditoriaId: any) {
  const result = await api.get(`${URLS.AUDITORIA_ID_API.replace('id', auditoriaId.toString())}`)
  .then((resp => resp.data));
  return result;
}
